import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-send-offers-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './send-offers-dialog.component.html',
  styleUrls: ['./send-offers-dialog.component.scss']
})
export class SendOffersDialogComponent {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onConfirmModal = new EventEmitter<string>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onCancelModal = new EventEmitter<string>();

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { programType: string; totalFunding?: number; numberOfAwards?: number; remainingFunds?: number }
  ) {}

  public onConfirmDialog(): void {
    this.onConfirmModal.emit();
  }
  public onCloseDialog(): void {
    this.onCancelModal.emit();
  }
}
